import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";

import jquery from "jquery";
import metismenu from "metismenu";
import bootstrap from "bootstrap";

import "./index.css"; // Tailwind CSS를 Bootstrap 이후에 로드하여 우선순위 확보

import App from "./App";

// 앱 렌더링 함수
const renderApp = () => {
  ReactDOM.render(<App />, document.getElementById("root"));
};

// 초기 렌더링
renderApp();

// 핫 모듈 리로딩(HMR) 설정
if (module.hot) {
  // App 컴포넌트 변경 감지
  module.hot.accept('./App', renderApp);
  
  // views/console 폴더 내 파일 변경 감지를 위한 추가 설정
  module.hot.accept('./views/console', () => {
    console.log('Console 폴더 내 파일이 변경되었습니다.');
    renderApp();
  });
}
